module.exports = __webpack_public_path__ + "static/img/fenXiangZhuan.5b0595a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newVcard/fenXiangZhuan.png
// module id = K2y0
// module chunks = 1